import { browserName, browserVersion } from 'react-device-detect'

// Chromium-based browsers are required for the main app because it relies on
// WebSerial for hardware connection (unavailable in Safari/Firefox).
export function isSupportedBrowser() {
    if (
        browserName === 'Chrome' ||
        browserName === 'Edge' ||
        browserName === 'Opera'
    ) {
        return parseInt(browserVersion) > 89
    }
    return false
}

// The standalone Play viewers are content-only (no hardware/WebSerial), so they
// are allowed to open in any browser, including Safari.
export const PLAY_VIEWER_PREFIXES = ['/playdynamex', '/playmex']

export function isPlayViewerPath(pathname) {
    return PLAY_VIEWER_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}
